<template lang="">
  <transition name="ms-zoom-in-center">
    <component
      :is="tagName"
      :class="classes"
      @click="handleClick"
    >
      <slot />
      <div
        v-if="closable"
        class="ms-tag__close"
        @click="handleClose"
      />
    </component>
  </transition>
</template>

<script>
import { computed } from 'vue'

const CLOSE_EVENT = 'close'

export default {
  emis: [CLOSE_EVENT],

  props: {
    tagName: {
      type: String,
      default: 'span',
    },
    // Loại:
    // default - xám
    // success - xanh lá cây
    // info - xanh nước biển
    // warning - vàng (chưa style do guideline không có)
    // danger - đỏ
    // purple - tím
    type: {
      type: String,
      default: 'default',
    },
    // Kích thước của Tag: large / default /small
    size: {
      type: String,
      default: 'default',
    },
    // Có show icon đóng không
    closable: {
      type: Boolean,
      default: false,
    },
    // Có bo tròn hai đầu không
    round: {
      type: Boolean,
      default: false,
    },
    // dark / light / plain
    effect: {
      type: String,
      default: 'light',
    },
  },

  setup (props, { emit }) {
    const classes = computed(() => {
      return [
        'ms-tag',
        `ms-tag--${props.type}`,
        `ms-tag__size--${props.size}`,
        `ms-tag--${props.effect}`,

      ]
    })

    const handleClick = () => {

    }

    const handleClose = () => {
      emit(CLOSE_EVENT)
    }

    return {
      classes,
      handleClick,
      handleClose,
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/components/MsTag.scss';
</style>
